import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["eventAnchor", "recurAnnually"];
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { CLASSIC_VIRTUAL_ANCHORED_DELAY } from 'automation-ui-action-features/actions/ActionMetadataConfigs';
import ClassicVirtualAnchoredDelayActionMetadata from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/records/ClassicVirtualAnchoredDelayActionMetadata';
import ClassicVirtualAnchoredDelayActionDetail from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/ClassicVirtualAnchoredDelayActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
function ClassicVirtualAnchoredDelayActionCard(_ref) {
  let {
      eventAnchor = {},
      recurAnnually = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    icon,
    theme
  } = CLASSIC_VIRTUAL_ANCHORED_DELAY;
  const actionMetadata = new ClassicVirtualAnchoredDelayActionMetadata({
    recurAnnually
  });
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerIcon: icon,
    headerTitle: CLASSIC_VIRTUAL_ANCHORED_DELAY.getActionLabel(),
    content: /*#__PURE__*/_jsx(ClassicVirtualAnchoredDelayActionDetail, {
      actionMetadata: actionMetadata,
      eventAnchor: eventAnchor
    }),
    titleUseTheme: theme
  }));
}
export default ClassicVirtualAnchoredDelayActionCard;